export const CASES = {
    UPDATE_LINKED_PRODUCTS: 'UPDATE_LINKED_PRODUCTS',
    UPDATE_LINKED_PRODUCTS_FORM: 'UPDATE_LINKED_PRODUCTS_FORM',
    CLEAR_LINKED_PRODUCTS: 'CLEAR_LINKED_PRODUCTS',
};
